<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="py-0">
      <v-row no-gutters>
        <v-col cols="1">
          <div class="pa-1 text-center" v-bind:class="httpTypeClass">
            <span class="white--text">{{ httpType }}</span>
          </div>
        </v-col>
        <v-col cols="2" class="px-3 py-1 font-weight-bold">{{ title }}</v-col>
        <v-col cols="7" class="px-3 py-1 text--secondary">{{ path }}</v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <wapi-panel :title="'Описание'">
        <template v-slot:content>
          <slot name="description"></slot>
        </template>
      </wapi-panel>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import WapiPanel from "../components/WapiPanel";

export default {
  name: "wapi-api-panel",
  components: {
    WapiPanel
  },
  props: {
    value: Array,
    title: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: ""
    },
    width: Number,
    httpType: {
      validator: function(value) {
        // Значение должно соответствовать одной из этих строк
        return ["GET", "POST", "PUT", "DELETE"].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    httpTypeClass() {
      switch (this.httpType) {
        case "GET":
          return "success";
        case "POST":
          return "primary";
        case "PUT":
          return "warning";
        case "DELETE":
          return "error";
        default:
          return "grey";
      }
    }
  },
  data() {
    return {
      showOptions: true
    };
  }
};
</script>